import { useEffect } from 'react';
import { initGA, trackPageView } from '@/utils/analytics';

interface GoogleAnalyticsProps {
  measurementId: string;
}

/**
 * Google Analytics component that initializes GA4 tracking.
 * Place this component in your app's root component.
 */
const GoogleAnalytics = ({ measurementId }: GoogleAnalyticsProps) => {
  useEffect(() => {
    // Initialize Google Analytics
    initGA(measurementId);

    // Track initial page view
    trackPageView(window.location.pathname + window.location.search);

    // Cleanup: clear GA globals when component unmounts (consent revoked)
    return () => {
      delete (window as any).gtag;
      (window as any).dataLayer = [];
    };
  }, [measurementId]);

  return null;
};

export default GoogleAnalytics;
